import { useState } from "react"

export const VariableVCards =() => {
    const [state, setState] = useState({
        url_alias: '',
        vcard_name: '',
        profile_image: '',
        cover_image: '',
        description: "",
        occupation: "",
        open: false,
        openEdit: false,
        arr1: [],
        Load: false
    })
    const setStateCustom = (variableName, value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            [variableName]: value,
        }));
    };
    const setLoad = (value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            Load: value,
        }));
    };
    const setOpen = (value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            open: value,
        }));
    };
    const setopenEdit = (value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            openEdit: value,
        }));
    };
    const handleEdit= (event, arr) => {
        event.preventDefault();
        setState((prevState) => ({
            ...prevState,
            arr1: arr,
            openEdit: true
        }));
    }
  return {
    ...state,
    state,
    setState,
    handleEdit,
    setOpen,
    setopenEdit,
    setStateCustom,
    setLoad
  }
}

